const SPECS = ["battery", "camera", "storage"];
const PRICING = ["lowDownPayment", "lowTotalCost", "lowWeeklyPayments"];

export const surveyTransformerSpecs = (answer: number): string => {
  return SPECS[answer];
};

export const surveyTransformerPrice = (answer: number): string => {
  return PRICING[answer];
};
